import { Task } from '@atom/types/task';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ApprovalGroup from './ApprovalGroup';
import {
  getApprovals,
  getTaskThreshold,
  Signatory,
} from './hidotOvertimeReportUtilities';
import ReportSection from './ReportSection';

import classes from './hidotOvertimeReport.module.css';

const REQUEST_SUBMITTED_BY: Signatory = {
  name: '',
  title: '(TYPE IN NAME, Title)',
};

type ApprovalsSectionProps = {
  task: Task;
};

const ApprovalsSection = ({ task }: ApprovalsSectionProps) => {
  const { recommendApproval, approver } = getApprovals(getTaskThreshold(task));

  return (
    <ReportSection title="Approvals" className={classes.approvals}>
      <ApprovalGroup
        title="Request Submitted By"
        signatories={[REQUEST_SUBMITTED_BY]}
      />
      {!isNilOrEmpty(recommendApproval) && (
        <ApprovalGroup
          title="Recommend Approval"
          signatories={recommendApproval}
        />
      )}
      <ApprovalGroup title="Approver" signatories={[approver]} />
    </ReportSection>
  );
};

export default ApprovalsSection;
